// src/pages/TermsOfUse.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{ height: "40px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Content */}
      <Container
        maxWidth="md"
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          background: "rgba(255, 255, 255, 0.97)",
          borderRadius: "10px",
          padding: "30px 20px",
          color: "#333",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Terms of Use
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Last Updated: December 2025
        </Typography>
        <Typography variant="body2" paragraph>
          YourStoryWorld is operated by Yourstoryworld Ltd (Company No.
          17098564), United Kingdom. These Terms govern your use of our website,
          apps and storytelling platform. By creating an account or using the
          service, you agree to these Terms.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Who can use YourStoryWorld
        </Typography>
        <Typography variant="body2" paragraph>
          The platform is intended for children, families, tutors and schools.
          However, accounts must be created and managed by an adult (such as a
          parent, carer, teacher or school administrator).
        </Typography>
        <Typography variant="body2" paragraph>
          By registering, you confirm that:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              You are at least 18, or acting with the consent of a parent/carer
              or school.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Any child data you add is done so lawfully and with appropriate
              consent.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          2. Accounts, security & access
        </Typography>
        <Typography variant="body2" paragraph>
          You are responsible for keeping your login details safe and for all
          activity on your account. If you suspect unauthorised access, please
          contact us immediately at{" "}
          <a href="mailto:support@yourstoryworld.com">
            support@yourstoryworld.com
          </a>
          .
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Acceptable use
        </Typography>
        <Typography variant="body2" paragraph>
          You agree not to:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Use the platform in any way that is unlawful, harmful, or
              inappropriate for children.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Attempt to reverse-engineer, copy or misuse our code or services.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Upload or input content that is hateful, abusive, explicit or
              otherwise unsuitable for young users.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Share login details widely (for example, one family or school
              account being used by far more users than licensed).
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. AI-generated content
        </Typography>
        <Typography variant="body2" paragraph>
          Stories and related content are generated with the help of artificial
          intelligence. While we design our prompts and filters to be
          age-appropriate:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Content may occasionally contain factual errors or odd phrasing.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Parents and teachers should supervise and review content where
              appropriate.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              YourStoryWorld is not a substitute for professional educational,
              psychological or medical advice.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Subscriptions, billing & trials
        </Typography>
        <Typography variant="body2" paragraph>
          We offer Free, Personal, Family and School plans, plus any other
          packages described on our website. Where third-party providers (such
          as Stripe) handle billing, their terms also apply.
        </Typography>
        <Typography variant="body2" paragraph>
          Any free trials or promotional offers are time-limited and may be
          changed or withdrawn at our discretion. Details will be displayed at
          the point of sign-up.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Intellectual property
        </Typography>
        <Typography variant="body2" paragraph>
          The YourStoryWorld platform, including its code, design, branding and
          dashboards, is owned by EZAA EduPlatform Ltd or used under licence.
          You are granted a personal, non-transferable licence to use the
          service for your own household or school, in line with your chosen
          plan.
        </Typography>
        <Typography variant="body2" paragraph>
          You retain rights in any original material you input (such as names or
          ideas), but you grant us a licence to use that input to generate and
          improve stories, and to operate the service.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Availability & changes
        </Typography>
        <Typography variant="body2" paragraph>
          We aim to provide a reliable service, but there may be occasional
          interruptions (for example, for maintenance or due to third-party
          outages). We may change or update parts of the platform from time to
          time to improve features, security or performance.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Ending or suspending accounts
        </Typography>
        <Typography variant="body2" paragraph>
          You may cancel your account at any time by contacting us. We may
          suspend or close an account where:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              There is serious or repeated breach of these Terms.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              We detect abuse, fraud or security issues.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          9. Limitation of liability
        </Typography>
        <Typography variant="body2" paragraph>
          Nothing in these Terms limits your rights under consumer law. However,
          to the fullest extent permitted by law, we are not liable for:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Any indirect or consequential loss arising from use of the
              platform.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Content generated by AI that you feel is unsuitable where filters
              were correctly configured and reasonable steps taken.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          10. Changes to these Terms
        </Typography>
        <Typography variant="body2" paragraph>
          We may update these Terms periodically, for example to reflect
          changes in the law or our services. The date at the top will be
          updated and, where changes are material, we will notify you via the
          platform or email where appropriate.
        </Typography>

        <Typography variant="h6" gutterBottom>
          11. Contact
        </Typography>
        <Typography variant="body2" paragraph>
          If you have any questions about these Terms, please contact:
          <br />
          <strong>support@yourstoryworld.com</strong>
        </Typography>
      </Container>
    </div>
  );
};

export default TermsOfUse;
